import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isValidFixType, VulnerabilitiesFilterKeys } from '../../../../shared/organizationPackages';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import { CheckboxFilterGroup } from '../../generic/Filter';
import type { AnyFilter } from '../../../../shared/organizationPackages';

const FIX_TYPE_OPTIONS = [
  { key: 'has_fix', label: 'Has fix' },
  { key: 'no_fix', label: 'No fix' },
];

type Props = {
  setFilters: (filter: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersVulnHasFix displays two checkboxes which can be used to
 * filter packages by those that have fixable / unfixable vulns.
 */
const PackageInventoryFiltersVulnHasFix: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const fixTypes = useSelector(PackageInventoryStore.selectors.getFiltersVulnFixTypes);
  const onSelect = (fixType: string, isChecked: boolean) => {
    if (!isValidFixType(fixType)) {
      return;
    }

    if (isChecked) {
      setFilters({ [VulnerabilitiesFilterKeys.FixTypes]: [...fixTypes, fixType] });
    } else {
      setFilters({ [VulnerabilitiesFilterKeys.FixTypes]: fixTypes.filter((opt) => opt !== fixType) });
    }
  };
  return (
    <CheckboxFilterGroup
      title="Fixable"
      options={FIX_TYPE_OPTIONS}
      selectedOptions={fixTypes}
      onSelect={onSelect}
      testId="package-inventory-filters-vuln--has-fix"
    />
  );
};

export default PackageInventoryFiltersVulnHasFix;
